// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"333":"e92d6455","540":"d19661cf"}[chunkId] + ".css";
};